module.exports = __webpack_public_path__ + "img/b.e3f88614.png";